import { render, staticRenderFns } from "./SetLanguage.vue?vue&type=template&id=250bc080"
import script from "./SetLanguage.vue?vue&type=script&lang=js"
export * from "./SetLanguage.vue?vue&type=script&lang=js"
import style0 from "./SetLanguage.vue?vue&type=style&index=0&id=250bc080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports